import React, { FC } from 'react';
import TargetService from 'services/TargetService/target.service';
import COButton from 'shared/components/COButton';
import OrganizationModal from 'shared/components/OrganizationModal';
import styles from './deleteModal.module.scss';
import { useUserRole } from 'shared/hooks/useUserRole';
import { canDelete } from 'shared/utils/roleUtils';
import Notification from 'shared/components/Notification';
import { NotificationTypes } from 'enums/notificationTypes';

interface DeleteLocationModalProps {
  isModalOpen: boolean;
  setIsModalOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  targetId?: number;
  fetchSbtiTargets?:() => Promise<void>
}

const DeleteTargetModal: FC<DeleteLocationModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  targetId,
  fetchSbtiTargets
}) => {
  const { loading, deleteTarget } = TargetService();
  const userRole = useUserRole();
  const canDeleteTarget = canDelete(userRole);
  const handleClose = () => setIsModalOpen?.(false);

  const handleDelete = async () => {
    if (!canDeleteTarget) {
      Notification({
        message: "You don't have admin access to add location and year",
        description: '',
        type: NotificationTypes.WARNING,
      });
      setIsModalOpen?.(false);
      return;
    }
    targetId && await deleteTarget(targetId);
    setIsModalOpen?.(false);
    await fetchSbtiTargets?.()
  };

  return (
    <div>
      <OrganizationModal
        visible={isModalOpen}
        onClose={handleClose}
        children={
          <div className={styles.deleteModalContainer}>
            <div className={styles.deleteTitleTextContainer}>
              Are you sure you want to delete this target?
            </div>
            <div className={styles.buttonContainer}>
              <COButton
                danger
                loading={loading}
                children="Delete"
                onClick={handleDelete}
              />
              <COButton secondary children="Cancel" onClick={handleClose} />
            </div>
          </div>
        }
      />
    </div>
  );
};

export default DeleteTargetModal;
